import React from 'react';
import PropTypes from 'prop-types';

import ContactCircleSave from './ContactCircleSave';
import withModal from '../modal/withModal';

const propTypes = {
  actionProps: PropTypes.shape({
    circle: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const ContactCircleSaveModal = ({ actionProps, ...props }) => {
  const { circle, contactsOnly } = actionProps ?? {};
  return (
    <ContactCircleSave
      circleId={circle?.id}
      contactsOnly={contactsOnly}
      {...props}
    />
  );
};

ContactCircleSaveModal.propTypes = propTypes;

export const CONTACT_CIRCLE_SAVE_MODAL = 'modal/CONTACT_CIRCLE_SAVE';

export default withModal(ContactCircleSaveModal, {
  name: CONTACT_CIRCLE_SAVE_MODAL,
  dismissible: true,
  size: 'md',
  type: 'full',
});
